<template>
  <quillEditor
    class="cl-quill-Editor"
    ref="quillEditor"
    v-model="message"
    @change="editChange($event)"
    :options="editorOption"
  >
    <div id="cl-quill-toolbar" slot="toolbar">
      <a-tooltip placement="bottom" overlayClassName="overlayClassName">
        <template slot="title">
          <span>{{$t('expression')}}</span>
        </template>
        <img class="pc-icon" v-if="config.expression == '1'" :src="require('@/assets/img/self-channel-icon/pc-face.png')"  @click="showFaceBox"/>
      </a-tooltip>
      <a-tooltip placement="bottom" overlayClassName="overlayClassName">
        <template slot="title">
          <span>{{$t('sendfile')}}</span>
        </template>
        <label class="icon-tools" v-if="config.sendFile == '1'">
          <!-- <i class="fa fa-folder-o"></i> -->
          <img class="pc-icon" :src="require('@/assets/img/self-channel-icon/pc-fold.png')" />
          <input type="file" style="display: none" @change="uploadFile" />
        </label>
      </a-tooltip>
      <a-tooltip placement="bottom" overlayClassName="overlayClassName" >
        <template slot="title">
          <span>{{$t('satisfyEvaluation')}}</span>
        </template>
        <!-- <i v-if="config.evaluate == '1' && feedBackConfig.isOpen && groupStatus === '1'" class="fa fa-heart-o icon-tools" @click="show_satisfaction"></i> -->
        <img class="pc-icon" v-if="config.evaluate == '1' && feedBackConfig.isOpen && groupStatus === '1'"  @click="show_satisfaction" :src="require('@/assets/img/self-channel-icon/pc-evaluation.png')" />
      </a-tooltip>
      <a-tooltip placement="bottom" overlayClassName="overlayClassName">
        <template slot="title">
          <span>{{$t('message')}}</span>
        </template>
        <i v-if="leaveMesageConfig.isOpen && leaveMesageConfig.isShowButton" style="position: relative; z-index: 30" class="fa fa-envelope icon-tools" @click="showLeaveMessage"></i>
      </a-tooltip>
    </div>
  </quillEditor>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import {mapState, mapActions, mapGetters} from 'vuex'
import ajax from '@/ajax/axios-ajax.js'
import apis from '@/apis/index.js'
export default {
  inject: ['showFaceBox', 'openUploadFileModal', 'show_satisfaction', 'showLeaveMessage', 'sendMediaMessage', 'previewTextMessage', 'transferLabor'],
  components: {
    quillEditor
  },
  computed: {
    ...mapState({
      config: 'config', // 渠道权限
      feedBackConfig: 'feedBackConfig', // 满意度权限
      leaveMesageConfig: 'leaveMesageConfig', // 留言权限
      visitorInfo: 'visitorInfo'
    }),
    ...mapGetters({
      serviceId: 'serviceId',
      groupStatus: 'groupStatus'
    })
  },
  data () {
    return {
      message: '',
      editorOption: {
        modules: {
          toolbar: '#cl-quill-toolbar',
          keyboard: {
            bindings: {
              enter: {
                key: 'enter',
                handler: (rang, context) => {
                  this.$emit('sendMessage')
                  return false
                }
              },
              shiftEnter: {
                key: 'enter',
                shiftKey: true,
                handler: (rang, context) => {
                  /*
                  let getLength = this.$refs.quillEditor.quill.getText().trim().length
                  this.$refs.quillEditor.quill.insertEmbed(getLength, 'p')*/
                  this.insertHtml('<p></p>')
                }
              }
            }
          }
        },
        placeholder: this.$t('inputContent')
      }
    }
  },
  methods: {
    editChange (ev) {
      this.previewTextMessage(ev.html)
      // if (ev.html) {
      //   this.previewTextMessage(ev.html)
      // }
    },
    insertText (val) {
      let getLength = this.$refs.quillEditor.quill.getText().trim().length
      this.$refs.quillEditor.quill.insertText(getLength, val)
    },
    insertHtml (val) {
    },
    // 上传文件
    uploadFile (ev) {
      let files = ev.target.files[0]
      if (!files) {
        return
      }
      let params  = new FormData()
      params.append('tenantId', this.visitorInfo.tenantId)
      params.append('file', files)
      ajax.post(apis.chat.upload, params).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          let obj = {
            ...res.data,
            fileName: files.name,
          }
          this.sendMediaMessage(obj)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  mounted () {}
}
</script>
<style scoped lang="less">
  #cl-quill-toolbar{
    padding: 5px 10px;
    border: none;
    .icon-tools{
      cursor: pointer;
    }
  }
  .pc-icon {
    width: 20px;
    height: 20px;
    margin: 12px 10px;
  }
</style>
<style lang="less">
  .cl-quill-Editor{
    .ql-container{
      border: none !important;
      height: 100px !important;
    }
  }
</style>
